<template>
  <div id="createSnippetContentBlock">
    <div class="stdBlockContent">
      <div class="stdSection selfClear">
        <div class="stdSectionContent">
          <div class="jsContentTextContainer snippet-text-editor">
            <textarea
              v-model="field"
              :disabled="readonly"
              class="el-input__inner"
              :class="[
                'jsContentInput',
                'stdTextarea',
                readonly ? 'disabled' : ''
              ]"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentEditor from '@/jquery/widgets/contentEditor'

export default {
  name: 'SnippetTextEditor',

  data() {
    return {
      field: this.modelField,
      // eslint-disable-next-line
      source: $('textarea').html()
    }
  },

  props: {
    modelField: {
      required: true
    },
    readonly: {
      required: false,
      type: Boolean
    },
    snippets: {
      required: false,
      type: Boolean,
      default: true
    }
  },

  mounted() {
    // eslint-disable-next-line no-undef
    let container = $('#createSnippetContentBlock').find(
      '.jsContentTextContainer'
    )

    // eslint-disable-next-line no-new
    new ContentEditor(container, {
      personalization: true,
      emojis: true,
      snippets: this.snippets
    })

    // eslint-disable-next-line
    $('body').on('change', this.event)
  },

  beforeDestroy() {
    // eslint-disable-next-line
    $('body').off('change', this.event)
  },

  watch: {
    field() {
      this.$emit('updateContent', this.field)
    },
    modelField() {
      this.field = this.modelField
    }
  },

  methods: {
    setContent(content) {
      if (!content) {
        content = ''
      }
      $('textarea')[0].value = content
    },

    event() {
      // eslint-disable-next-line
      this.field = $('textarea')[0].value
    }
  }
}
</script>

<style scoped>
.disabled {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/modules/snippets/components/SnippetTextInput.vue